export default __webpack_public_path__ + "static/media/ay-technologies-black.fca08d92.svg";